import React from 'react';
import { CreditCardIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
type TrustSealsProps = {
  tone?: 'light' | 'dark';
};
const seals = [{
  label: 'Pago único',
  Icon: CreditCardIcon
}, {
  label: 'Acceso inmediato',
  Icon: ZapIcon
}, {
  label: 'Garantía 7 días',
  Icon: ShieldCheckIcon
}];
export function TrustSeals({
  tone = 'dark'
}: TrustSealsProps) {
  const text = tone === 'light' ? 'text-cream/90' : 'text-ink-muted';
  const icon = tone === 'light' ? 'text-gold-light' : 'text-gold-deep';
  return <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-146" data-mp="t2lnbe2pqqjv">
      {seals.map(({
      label,
      Icon
    }) => <li key={label} className={`flex items-center gap-1.5 whitespace-nowrap text-xs font-semibold sm:text-sm ${text}`} data-id="element-147" data-mp="o4tlnsc9nq2h">
          <Icon className={`h-4 w-4 ${icon}`} strokeWidth={1.75} aria-hidden="true" data-id="element-148" data-mp="f3vr00npwuwk" />
          {label}
        </li>)}
    </ul>;
}